var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_30782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.604 15.8687L11.431 10.6957C12.406 9.55866 13 8.08466 13 6.47266C13 2.88866 10.084 -0.0273438 6.5 -0.0273438C4.764 -0.0273438 3.131 0.648656 1.902 1.87566C0.675001 3.10366 -0.000998892 4.73666 1.10788e-06 6.47266C1.10788e-06 10.0567 2.916 12.9727 6.5 12.9727C8.112 12.9727 9.587 12.3787 10.724 11.4037L15.897 16.5767L16.604 15.8687ZM6.5 11.9727C3.468 11.9727 1 9.50566 1 6.47266C0.999001 5.00266 1.571 3.62166 2.61 2.58366C3.648 1.54466 5.03 0.972656 6.5 0.972656C9.532 0.972656 12 3.43966 12 6.47266C12 9.50466 9.532 11.9727 6.5 11.9727Z",
    fill: "#68717A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_30782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSearch);
export default __webpack_public_path__ + "static/media/smallSearch.7638612548d68b3d1e66b19c8b045b81.svg";
export { ForwardRef as ReactComponent };